import React, { useMemo, useRef, useCallback } from 'react';
import styled from 'styled-components/macro';

import useFlavorStore from '../../../../../common/store/useFlavorStore';
import Container from '../../Container';
import { getVh } from '../../utils';
import useParallax from '../../useParallax';
import useAnimation from './useAnimation';

const Uno = styled.img`
  aspect-ratio: 149/198;
  width: 90rem;
  height: auto;

  transform: rotate(-90deg);
`;

const Dos = styled.img`
  aspect-ratio: 232/147;
`;

const Tres = styled.img`
  aspect-ratio: 212/137;
  width: 150rem;
  height: auto;
`

const Blueberry = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  const ref = {
    figure: {
      uno: useRef<HTMLElement>(null),
      dos: useRef<HTMLElement>(null),
      tres: useRef<HTMLElement>(null)
    },
    img: {
      uno: useRef<HTMLImageElement>(null),
      dos: useRef<HTMLImageElement>(null),
      tres: useRef<HTMLImageElement>(null)
    }
  }

  const top = {
    uno: useMemo(() => getVh("flavor", 0.65), []),
    dos: useMemo(() => getVh("flavor", 0.4), []),
    tres: useMemo(() => getVh("flavor", 0.25), [])
  }

  useAnimation(flavor === "blueberry", [ref.figure.uno, ref.figure.dos, ref.figure.tres]);

  useParallax(ref.img.uno, top.uno, 150);
  useParallax(ref.img.dos, top.dos, 100);
  useParallax(ref.img.tres, top.tres, 150);

  return (
    <>
      <Container
        ref={ref.figure.uno}
        top={top.uno}
        style={{ left: "60vw" }}
      >
        <Uno
          ref={ref.img.uno}
          src="/static/images/fill/blueberry/1.png"
        />
      </Container>

      <Container
        ref={ref.figure.dos}
        top={top.dos}
        style={{ left: "70vw" }}
      >
        <Dos
          ref={ref.img.dos}
          src="/static/images/fill/blueberry/2.png"
        />
      </Container>

      <Container
        ref={ref.figure.tres}
        top={top.tres}
        style={{ right: "15vw" }}
      >
        <Tres
          ref={ref.img.tres}
          src="/static/images/fill/blueberry/3.png"
        />
      </Container>
    </>
  );
}

export default Blueberry;